import script from "./QuestionGroupTestList.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionGroupTestList.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionGroupTestList.vue?vue&type=style&index=0&id=0c527a7a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c527a7a"]])

export default __exports__